import { Either, isLeft } from 'fp-ts/lib/Either';
import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import { parseWeatherData } from 'src/utils/parseWeatherData';
import { WeatherData } from 'src/state/WeatherData';

export function* fetchWeatherData(url: string): SagaIterator {
    const response: Response = yield call(fetch, url);
    const body: string = yield call({
        fn: response.text,
        context: response
    });

    const weatherData: Either<string, WeatherData> = yield call(parseWeatherData, body);
    if (isLeft(weatherData)) {
        throw new Error(`Could not parse weather data: ${weatherData.left}`);
    }

    return weatherData.right;
}
